module.exports = __webpack_public_path__ + "static/media/adam.534e7f54.jpeg";